import { fetchData, APIMethod, ACCESS_DOMAINS } from "@client";

export async function getCounterQuery(jiraExportId) {
  return await fetchData(`api/projects/counter/${jiraExportId}`, APIMethod.GET, {
    baseURL: ACCESS_DOMAINS.btApi,
  });
}